import { UserSession } from '../models';

export const UserSessionMocks: UserSession = {
  enrollmentDate: '2004-05-27',
  prefix: 'Mr',
  firstName: 'Rocky',
  is360Tier: false,
  isAbove18: false,
  lastName: 'Olive',
  loggedIn: true,
  medallionMbrInd: '0',
  medallionMemberDesc: 'Diamond Medallion',
  membershipLevel: 'DM',
  middleName: '',
  millionMiler: false,
  millionMilerTier: '0',
  skyPriority: true,
  skymilesMember: true,
  smBalance: '38000',
  smNumber: '8006270311',
  cobrandCardtypeList: 'AXCV',
  countryCode: 'US',
  hasPhone: true,
  preferredName: 'FR',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  skyClubMembershipDiscontinueDate: '2025-09-05',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: '',
  email: 'test.tesing@delta.com'
};

export const UserSessionJPNMocks: UserSession = {
  enrollmentDate: '2004-05-27',
  firstName: 'Nelson',
  is360Tier: false,
  isAbove18: false,
  lastName: 'Olive',
  loggedIn: true,
  medallionMbrInd: '0',
  medallionMemberDesc: 'Diamond Medallion',
  membershipLevel: 'DM',
  middleName: '',
  millionMiler: false,
  millionMilerTier: '0',
  skyPriority: true,
  skymilesMember: true,
  smBalance: '38000',
  smNumber: '8006270311',
  cobrandCardtypeList: 'AXCV',
  countryCode: 'JPN',
  hasPhone: true,
  preferredName: 'FR',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  skyClubMembershipDiscontinueDate: '2025-09-05',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: '',
  email: 'test.tesing@delta.com'
};

export const UserSessionNoMedallionStatusMocks: UserSession = {
  enrollmentDate: '2004-05-27',
  firstName: 'Rocky',
  is360Tier: false,
  isAbove18: false,
  lastName: 'Olive',
  loggedIn: true,
  medallionMbrInd: '0',
  membershipLevel: 'DM',
  middleName: '',
  millionMiler: false,
  millionMilerTier: '0',
  skyPriority: true,
  skymilesMember: true,
  smBalance: '38000',
  smNumber: '8006270311',
  cobrandCardtypeList: 'AXCV',
  countryCode: 'US',
  hasPhone: true,
  preferredName: 'FR',
  isSkyClubMember: 'Y',
  skyClubMemberType: 'I',
  skyClubMembershipDiscontinueDate: '2025-09-05',
  cobrandCardtypeAffiliationIdList: '',
  cobrandCardtypeDescList: '',
  cobrandCardtypeSkyclubEligibleList: '',
  email: 'test.tesing@delta.com'
};
